import { Link, useParams } from 'react-router-dom'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { DetailHeader } from '@/components/common/DetailHeader'
import { useTeams } from './hooks'
import { GeneralPanel } from './components/GeneralPanel'
import { MembersPanel } from './components/MembersPanel'
import { TeamVisibilityPanel } from './components/TeamVisibilityPanel'

export function TeamDetailPage() {
  const { id } = useParams<{ id: string }>()
  const teamId = id ? Number(id) : 0
  const teamsQ = useTeams(true)
  const team = teamsQ.data?.find(t => t.id === teamId)

  if (teamsQ.isLoading) return <div className="p-4">Ładowanie…</div>
  if (!team) {
    return (
      <div className="p-4">
        <p className="text-sm text-red-600">Zespół nie znaleziony.</p>
        <Link to="/admin/teams" className="text-sm text-sky-700 underline">← Zespoły</Link>
      </div>
    )
  }

  return (
    <div className="flex flex-col w-full h-full">
      <DetailHeader
        title={team.name}
        subtitle={
          <span className="font-mono">
            {team.code} · {team.isActive ? 'aktywny' : 'nieaktywny'}
          </span>
        }
      />

      <Tabs defaultValue="members" className="flex-1 flex flex-col gap-0 overflow-hidden">
        <TabsList className="rounded-none w-full justify-start gap-2 px-4 border-b bg-white h-auto">
          <TabsTrigger value="general">Ogólne</TabsTrigger>
          <TabsTrigger value="members">Członkowie</TabsTrigger>
          <TabsTrigger value="visibility">Widzialność</TabsTrigger>
        </TabsList>

        <TabsContent value="general" className="flex-1 overflow-auto p-4">
          <GeneralPanel team={team} />
        </TabsContent>
        <TabsContent value="members" className="flex-1 overflow-auto p-4">
          <MembersPanel teamId={team.id} />
        </TabsContent>
        <TabsContent value="visibility" className="flex-1 overflow-auto p-4">
          <TeamVisibilityPanel teamId={team.id} />
        </TabsContent>
      </Tabs>
    </div>
  )
}
